import { render } from "./List.ce.vue?vue&type=template&id=79a95f5b"
import script from "./List.ce.vue?vue&type=script&lang=js"
export * from "./List.ce.vue?vue&type=script&lang=js"

import _style_0 from "./List.ce.vue?vue&type=style&index=0&id=79a95f5b&inline&lang=scss"

import exportComponent from "/builds/govbr-ds/wbc/govbr-ds-wbc/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__